import React, { useEffect, useState } from "react";
import SubTaskForm from "./subTaskForm";
import { getSubTasks, updateSubTask } from "../../../../services/usersService";
import { Card, Dropdown, DropdownButton, ListGroup } from "react-bootstrap";
import { Divider, TextField, Typography } from "@material-ui/core";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
function SubTasks({
  taskID = 0,
  showSubTaskForm = false,
  taskStatus = [],
  setShowSubTaskForm,
}) {
  const [openSubTaskForm, setOpenSubTaskForm] = useState(false);
  const [subTasks, setSubTasks] = useState([]);
  useEffect(() => {
    getSubTasksData(taskID);
  }, [taskID]);

  return (
    <React.Fragment>
      {openSubTaskForm ? (
        <div className="row mt-3">
          <div className="col-6">
            <SubTaskForm
              taskID={taskID}
              onConfirmSave={() => {
                setOpenSubTaskForm(false);
                getSubTasksData(taskID);
              }}
              onCloseSubTask={() => {
                setOpenSubTaskForm(false);
              }}
            />
          </div>
        </div>
      ) : null}
      <div className="row my-3">
        <div className="col-sm-12 col-md-12 col-lg-12">
          {subTasks.length > 0 ? (
            <Typography className="kt-font-bolder mb-2">Sub Tasks</Typography>
          ) : null}
          {subTasks.length > 0 &&
            subTasks.map((subtask, index) => (
              <React.Fragment key={index}>
                {index > 0 ? <Divider /> : null}
                <div className="card border-0 px-3 py-2">
                  <div className="row">
                    <div className="col-sm-10 col-md-10 col-lg-10">
                      {subtask.displayType === "readonly" ? (
                        <React.Fragment>
                          <span>
                            <span className="mr-1">
                              <Typography className="d-inline">
                                {subtask.description}
                              </Typography>
                            </span>
                            <span className="mx-1">
                              <BootstrapTooltip title="Edit Sub Task">
                                <button
                                  type="button"
                                  className="btn btn-icon btn-clean btn-circle btn-sm"
                                  onClick={() => {
                                    const subTasksTmp = [...subTasks];
                                    subTasksTmp[index].displayType = "edit";
                                    setSubTasks(subTasksTmp);
                                  }}
                                >
                                  <i className="fas fa-pencil-alt pr-0"></i>
                                </button>
                              </BootstrapTooltip>
                            </span>
                          </span>
                        </React.Fragment>
                      ) : (
                        <TextField
                          size="small"
                          margin="none"
                          variant="outlined"
                          style={{ width: "100%", background: "white" }}
                          value={subtask.description}
                          autoFocus
                          onBlur={(e) => {
                            const updateSubTask = { ...subtask };
                            updateSubTask.description = e.target.value;
                            saveUpdateSubTask(updateSubTask);
                          }}
                          onChange={(e) => {
                            const subTasksTmp = [...subTasks];
                            subTasksTmp[index].description = e.target.value;
                            setSubTasks(subTasksTmp);
                          }}
                        />
                      )}
                    </div>
                    <div className="col-sm-2 col-md-2 col-lg-2">
                      <DropdownButton
                        className="float-right"
                        title={subtask.taskStatus.title}
                        variant={subtask.statusID === 9999 ? "success" : "info"}
                        size="sm"
                      >
                        {taskStatus.map((status, index2) => (
                          <Dropdown.Item
                            key={index2}
                            onClick={() => {
                              const updateSubTask = { ...subtask };
                              updateSubTask.statusID = status.value;
                              saveUpdateSubTask(updateSubTask);
                            }}
                          >
                            {status.label}
                          </Dropdown.Item>
                        ))}
                      </DropdownButton>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            ))}
        </div>
      </div>
      {showSubTaskForm ? (
        <SubTaskForm
          taskID={taskID}
          onConfirmSave={() => {
            getSubTasksData(taskID);
            setShowSubTaskForm(false);
          }}
          onCloseSubTask={() => {
            setShowSubTaskForm(false);
          }}
        />
      ) : null}
    </React.Fragment>
  );

  async function saveUpdateSubTask(subTask) {
    updateSubTask(subTask).then((response) => {
      getSubTasksData(taskID);
    });
  }

  async function getSubTasksData(taskID) {
    const response = await getSubTasks(taskID);
    const { data } = response.data;
    setSubTasks(data.subTasks);
  }
}
export default SubTasks;
